const SET_BILL_LIST = '@bill/set-bill-list';
const SET_BILL_DETAIL = '@bill/set-bill-detail';
const SET_BILL_LIST_TOTAL = '@bill/set-bill-list-total';

export {SET_BILL_LIST, SET_BILL_DETAIL, SET_BILL_LIST_TOTAL};
